import React, { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { Users, Package, ShoppingCart, IndianRupee } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid } from "recharts";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setD(r.data)); }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl font-bold">Dashboard</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={IndianRupee} label="Total Revenue" value={inr(d.total_revenue)} />
        <Stat icon={ShoppingCart} label="Total Orders" value={d.total_orders}/>
        <Stat icon={Users} label="Total Customers" value={d.total_customers}/>
        <Stat icon={Package} label="Total Products" value={d.total_products}/>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bg-white border border-slate-100 rounded-2xl p-5">
          <h3 className="font-display font-bold mb-3">Revenue (last 14 days)</h3>
          <div className="h-64">
            <ResponsiveContainer><LineChart data={d.daily}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7"/>
              <XAxis dataKey="date" tickFormatter={(t)=>t.slice(5)} fontSize={11}/>
              <YAxis fontSize={11}/>
              <Tooltip/>
              <Line type="monotone" dataKey="revenue" stroke="#004BCA" strokeWidth={2.5} dot={false}/>
            </LineChart></ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white border border-slate-100 rounded-2xl p-5">
          <h3 className="font-display font-bold mb-3">Orders by Day</h3>
          <div className="h-64">
            <ResponsiveContainer><BarChart data={d.daily}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7"/>
              <XAxis dataKey="date" tickFormatter={(t)=>t.slice(5)} fontSize={11}/>
              <YAxis fontSize={11}/>
              <Tooltip/>
              <Bar dataKey="orders" fill="#FF4500" radius={[6,6,0,0]}/>
            </BarChart></ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-[2fr_1fr] gap-4">
        <div className="bg-white border border-slate-100 rounded-2xl p-5">
          <h3 className="font-display font-bold mb-3">Top Products</h3>
          {d.top_products.length===0?<div className="text-sm text-slate-500">No sales yet.</div>:(
            <table className="w-full text-sm">
              <thead><tr className="text-xs uppercase text-slate-500"><th className="text-left py-2">Product</th><th>Qty</th><th className="text-right">Revenue</th></tr></thead>
              <tbody>{d.top_products.map((p,i)=>(
                <tr key={i} className="border-t border-slate-100"><td className="py-2 flex items-center gap-2"><img src={p.image} className="w-8 h-10 rounded object-cover"/>{p.title}</td><td className="text-center">{p.qty}</td><td className="text-right font-semibold">{inr(p.revenue)}</td></tr>
              ))}</tbody>
            </table>
          )}
        </div>
        <div className="bg-white border border-slate-100 rounded-2xl p-5">
          <h3 className="font-display font-bold mb-3">Orders by Status</h3>
          {Object.entries(d.status_counts).map(([s,c])=>(
            <div key={s} className="flex justify-between py-2 border-b border-slate-100 last:border-0 text-sm"><span>{s}</span><b>{c}</b></div>
          ))}
        </div>
      </div>
    </div>
  );
}
function Stat({ icon: Icon, label, value }) {
  return <div className="bg-white border border-slate-100 rounded-2xl p-5"><div className="flex items-center justify-between"><span className="text-xs text-slate-500 uppercase tracking-wider">{label}</span><Icon size={18} className="text-[#004BCA]"/></div><div className="font-display text-2xl font-bold mt-2">{value}</div></div>;
}
